import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCustomerDropshipperSearch = () => {
  const customerDropshipperSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/dropshipper/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { customerDropshipperSearch }
}

export default InteractorCustomerDropshipperSearch
